import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Container, Card, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    document.title = 'パスワードの再設定 | My Order System';
  }, []);

  /**
   * パスワードリセットメールを送信する処理
   * @param {React.FormEvent<HTMLFormElement>} e - フォーム送信イベント
   */
  const handleResetPassword = async (e) => {
    e.preventDefault(); // フォームのデフォルトの送信動作をキャンセル
    if (!email) {
      setError('メールアドレスを入力してください。');
      return;
    }
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Firebase Authenticationのパスワードリセットメール送信機能を呼び出す
      await sendPasswordResetEmail(auth, email);
      setSuccess(`パスワード再設定用のメールを ${email} に送信しました。メール内のリンクから再設定を行ってください。`);
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/user-not-found') {
        setError('このメールアドレスは登録されていません。');
      } else {
        setError('メールの送信に失敗しました。時間をおいて再度お試しください。');
      }
    } finally {
      setLoading(false); // 処理が成功・失敗いずれでもローディングを解除
    }
  };

  return (
    <main>
      <Container className="my-4 d-flex justify-content-center">
        <Card className="shadow-sm" style={{ width: '100%', maxWidth: '500px' }}>
          <Card.Header as="h2" className="p-3">パスワードの再設定</Card.Header>
          <Card.Body className="p-4">
            {success ? (
              // 送信成功時のメッセージ
              <Alert variant="success">{success}</Alert>
            ) : (
              // メール入力フォーム
              <>
                <p>
                  ご登録のメールアドレスを入力してください。パスワード再設定用のリンクをお送りします。<br/>
                  <small className="text-muted">
                    メールが届かない場合は、迷惑メールフォルダをご確認いただくか、時間をおいて再度お試しください。
                  </small>
                </p>
                <Form onSubmit={handleResetPassword}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>メールアドレス</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="例: user@example.com"
                      required
                    />
                  </Form.Group>
                  {error && <Alert variant="danger">{error}</Alert>}
                  <div className="d-grid">
                    <Button variant="primary" type="submit" disabled={loading}>
                      {loading ? <Spinner as="span" size="sm" /> : '再設定メールを送信'}
                    </Button>
                  </div>
                </Form>
              </>
            )}
            <div className="text-center mt-3">
              <Link to="/login">ログイン画面に戻る</Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}

export default ForgotPasswordPage;

